import LandingPage from '../components/landing/landing'

export default LandingPage
